if (!customElements.get('related-articles-section')) {
  class RelatedArticlesSection extends HTMLElement {
    constructor() {
      super();
      this.initSwiper();
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') {
        console.error('Swiper is not loaded');
        return;
      }

      const swiperEl = this.querySelector('[data-related-articles-carousel]');
      const nextBtn = this.querySelector('.related-articles-nav-next');
      const prevBtn = this.querySelector('.related-articles-nav-prev');
      
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1.088,
        spaceBetween: 20,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        breakpoints: {
          768: {
            slidesPerView: 2.088,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
    }
  }

  customElements.define('related-articles-section', RelatedArticlesSection);
}
